import Vue from 'vue'
import App from './App.vue'

import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

import VueRouter from "vue-router";
Vue.use(VueRouter);

import LandingPage from "./LandingPage.vue";
import AgentForm from "./AgentForm.vue";

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "/", component: LandingPage },
    { path: "/af", component: AgentForm },
  ],
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
